import type { NavigationContext } from "../../contexts";
import type { NavigationStateRecord, NavigationState } from "../../types";

/**
 * Retrieves the current record from the navigation state based on the navigation context.
 */
export function getMainRecordFromNavigationState(
  navigationContext: NavigationContext,
  navigationState: NavigationState,
): NavigationStateRecord | undefined {
  if (!navigationContext?.[0]) {
    return undefined;
  }

  return navigationState.find((value) => value.id === navigationContext[0]);
}
